import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["code", "placement", "position", "shades", "smallerOnMobile", "onClick"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useIsMobile } from '@ori/presentation-hooks';
import { IconButton } from '@ori-ui/components';
import { useCallback } from 'react';
import { FavoritesHeart } from "../FavoritesHeart";
import { jsx as _jsx } from "react/jsx-runtime";
export var FavoritesHeartIconButton = function FavoritesHeartIconButton(_ref) {
  var code = _ref.code,
    placement = _ref.placement,
    position = _ref.position,
    shades = _ref.shades,
    smallerOnMobile = _ref.smallerOnMobile,
    onClick = _ref.onClick,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var isMobile = useIsMobile();
  var handleClick = useCallback(function (e) {
    e.preventDefault();
    e.stopPropagation();
    onClick === null || onClick === void 0 ? void 0 : onClick(e);
  }, [onClick]);
  var renderFavoritesHeart = useCallback(function (heart, onFavoritesHeartClick) {
    return /*#__PURE__*/_jsx(IconButton, _objectSpread(_objectSpread({
      color: "default",
      size: smallerOnMobile && isMobile ? 'medium' : 'large',
      variant: "contained",
      onClick: onClick ? handleClick : onFavoritesHeartClick
    }, restProps), {}, {
      children: heart
    }));
  }, [handleClick, isMobile, onClick, restProps, smallerOnMobile]);
  return /*#__PURE__*/_jsx(FavoritesHeart, {
    code: code,
    placement: placement,
    position: position,
    shades: shades,
    render: renderFavoritesHeart
  });
};
//# sourceMappingURL=FavoritesHeartIconButton.js.map